module.exports = __webpack_public_path__ + "img/area.6d45e4f0.png";